import React from 'react';
import { useTranslation } from "react-i18next";
import { Container, Stack, Typography } from "@mui/material";
import { CustomStackFullWidth } from "../styled-components/CustomStyles.style";
import FourHundred from "../components/errors-svg/FourHundred";
import SEO from '../components/seo';

const NotFound = () => {
    const { t } = useTranslation();

  
  
  return (
    <>
      <SEO
        title="Page Not Found"
        description="The page you are looking for does not exist"
      />
      <Container
        maxWidth="lg"
        sx={{
          mt: { md: "5rem" },
          mb: { xs: "72px", md: "0" },
        }}
      >
        <CustomStackFullWidth
          justifyContent="center"
          alignItems="center"
          spacing={4}
        >
          <Stack maxWidth="500px" width="100%" spacing={2} padding="1rem">
            <FourHundred />
            <Typography align="center" variant="h3">
              {t("Something went wrong.")}
            </Typography>
          </Stack>
        </CustomStackFullWidth>
      </Container>
    </>
  );
};

export default NotFound;
